export default "__VITE_ASSET__Dw$ntNVh__"